import { render, staticRenderFns } from "./ModalSaveTemplate.vue?vue&type=template&id=5bcbdeac&scoped=true&"
import script from "./ModalSaveTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalSaveTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbdeac",
  null
  
)

export default component.exports